export default "__VITE_ASSET__BNP5f_1w__"